
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvTableFieldArray } from "bootstrap-vue";
import { i18n } from "@/i18n";
import { IThirdcode } from "@/entities";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import IconEdit from "@/components/common/icon/IconEdit.vue";
import AddEditThirdcodeModal from "@/components/thirdcode/AddEditThirdcodeModal.vue";

@Component({
  name: "thirdcode-table",
  components: {
    IconEdit,
    AddEditThirdcodeModal,
    IconTrash,
  },
})
export default class ThirdcodeTable extends Vue {
  @Prop({ required: false, default: null }) thirdcodeList!: IThirdcode[];
  private thirdcodeSelected: IThirdcode | null = null;
  public collapsed = true;

  constructor() {
    super();
  }

  get fields(): BvTableFieldArray {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-first align-middle",
      },
      {
        key: "system",
        label: i18n.t("label.system") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "code",
        label: i18n.t("label.code") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header py-0",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }

  removeThirdcode(index: number): void {
    this.thirdcodeList.splice(index, 1);
  }

  openNewThirdcodeModal(): void {
    this.thirdcodeSelected = null;
    this.$nextTick(() => this.$bvModal.show("addEditThirdcodeModal"));
  }
  editThirdcode(thirdcode: IThirdcode): void {
    this.thirdcodeSelected = thirdcode;
    this.$nextTick(() => this.$bvModal.show("addEditThirdcodeModal"));
  }
}
